import React, { useEffect, useState } from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { object, string } from "prop-types";
import { connect } from "react-redux";

import CardImage from "../../atoms/CardImage";
import { staticTexts } from "../../utils/Translate";
import { getStory } from "../../helper/api";

import "./alsoRead.m.css";

const AlsoRead = ({ element, lang }) => {
  const storyId = get(element, ["metadata", "linked-story", "id"], "");
  const [linkedStory, updatedlinkedStory] = useState(null);

  const getAlsoReadStoryData = async (storyId) => {
    try {
      const { story } = await getStory(storyId);
      updatedlinkedStory(story);
    } catch (err) {}
  };
  useEffect(() => {
    getAlsoReadStoryData(storyId);
  }, []);

  if (!linkedStory) {
    return null;
  }

  return (
    <span aria-label={linkedStory.headline} styleName="also-read" className="also-read">
      <h2 className="also-read-text">{staticTexts(lang).alsoRead}</h2>
      <Link href={linkedStory.slug}>
        <div styleName="wrapper">
          <h2>{linkedStory.headline}</h2>
          <CardImage
            story={linkedStory}
            aspectRatio={[3, 2]}
            imageType="image3x2"
            showAlternateImage={true}
            widths={[150]}
          />
        </div>
      </Link>
    </span>
  );
};

AlsoRead.propTypes = {
  element: object,
  lang: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(AlsoRead);
